import { render, staticRenderFns } from "./RecordList.vue?vue&type=template&id=546a4166&"
import script from "./RecordList.vue?vue&type=script&lang=js&"
export * from "./RecordList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports